// extracted by mini-css-extract-plugin
export default {"game-grid":"GameGrid_game-grid__CMRQI","game-grid--4x4":"GameGrid_game-grid--4x4__5aEQx","game-grid--6x6":"GameGrid_game-grid--6x6__RlUtf"};